<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()
const mainStyle = computed(() => ({
  top: '54px',
  height: 'calc(100% - 54px)',
  maxHeight: 'calc(100% - 54px)',
}))
</script>

<template>
  <div class="preview-Layout">
    <LayoutHeader :is-workbench="true" />
    <div :class="!route.query.operateRecordId ? 'main-free' : 'main'" :style="mainStyle">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="less" scoped>
.preview-Layout{
  display: flex;
  flex-direction: column;
  height: 100%;
  .main{
    display: flex;
    position: fixed;
    left:0;
    right:0;
    bottom: 0;
    overflow-y: hidden;
  }
  .main-free{
    display: flex;
    position: fixed;
    left:0;
    right:0;
    bottom: 0;
    overflow-y: auto;
  }
}
</style>
